// src/components/ActivityCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import {
    formatDistance,
    formatDuration,
    formatPace,
    formatDate,
    formatElevation,
    formatAltitude,
    formatAdjustedPace
} from '../utils/formatters';

const ActivityCard = ({ activity }) => {
    return (
        <article className="activity-card">
            {/* Serious Score Badge */}
            {activity.serious_score !== null && activity.serious_score !== undefined && (
                <div className={`serious-score-badge ${activity.serious_score >= 70 ? 'high' : activity.serious_score >= 40 ? 'medium' : 'low'}`}>
                    <span className="score-label">Serious Score</span>
                    <span className="score-value">{activity.serious_score}</span>
                </div>
            )}

            <div className="activity-header">
                <Link to={`/profile/${activity.user?.id}`} className="activity-avatar">
                    {activity.user?.username?.[0]?.toUpperCase() || '?'}
                </Link>
                <div className="activity-meta">
                    <div className="activity-user-row">
                        <Link to={`/profile/${activity.user?.id}`} className="activity-user">
                            {activity.user?.username || 'Unknown'}
                        </Link>
                        {(() => {
                            const score = activity.user?.average_serious_score;
                            if (score === null || score === undefined) return null;

                            let label, className;
                            if (score >= 100) { label = 'Kipchoge'; className = 'rank-kipchoge'; }
                            else if (score >= 75) { label = 'Pro'; className = 'rank-pro'; }
                            else if (score >= 50) { label = 'Serious Runner'; className = 'rank-serious'; }
                            else { label = 'Hobby Jogger'; className = 'rank-hobby'; }

                            return <span className={`rank-pill ${className}`}>{label}</span>;
                        })()}
                    </div>
                    <span className="activity-date">
                        {formatDate(activity.activity_date)}
                    </span>
                </div>
            </div>

            <h3 className="activity-name">{activity.name || 'Untitled Run'}</h3>

            <div className="activity-stats">
                <div className="stat">
                    <span className="stat-value">{formatDistance(activity.distance_meters)}</span>
                    <span className="stat-label">Distance</span>
                </div>
                <div className="stat">
                    <span className="stat-value">{formatDuration(activity.duration_seconds)}</span>
                    <span className="stat-label">Time</span>
                </div>
                <div className="stat">
                    <span className="stat-value">{formatPace(activity.pace_seconds_per_km)}</span>
                    <span className="stat-label">Pace</span>
                </div>
                {(activity.elevation_gain_meters > 0) && (
                    <div className="stat">
                        <span className="stat-value">↑ {formatElevation(activity.elevation_gain_meters)}</span>
                        <span className="stat-label">Elev Gain</span>
                    </div>
                )}
                {activity.altitude_avg_meters && (
                    <div className="stat">
                        <span className="stat-value">{formatAltitude(activity.altitude_avg_meters)}</span>
                        <span className="stat-label">Avg Altitude</span>
                    </div>
                )}
                <div className="stat stat-highlight">
                    <span className="stat-value">{formatAdjustedPace(activity.pace_seconds_per_km, activity.altitude_avg_meters, activity.elevation_gain_meters, activity.distance_meters)}</span>
                    <span className="stat-label">Excuse Pace</span>
                </div>
            </div>

            {/* AI Summary */}
            {activity.serious_summary && (
                <div className="activity-summary">
                    <p>{activity.serious_summary}</p>
                </div>
            )}
        </article>
    );
};

export default ActivityCard;
